export default __webpack_public_path__ + "static/media/pop_hazards_human_detection.936bd2f2.svg";